// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { orderTotalDisplaySharedStyles } from "@conklin/App/SharedStyles/MyAccountPages/Details/OrderTotalDisplaySharedStyles";
import { cartTotalDisplayStyles } from "@conklin/Overrides/Components/CartTotalDisplay";

cartTotalDisplayStyles.container = {
    ...orderTotalDisplaySharedStyles.mainContainer,
};
cartTotalDisplayStyles.orderSummaryLabel = {
    ...orderTotalDisplaySharedStyles.titleText,
};
cartTotalDisplayStyles.fullWidthGridItem = {
    width: 12,
};
cartTotalDisplayStyles.styledHr = {
    ...orderTotalDisplaySharedStyles.styledHr,
};
cartTotalDisplayStyles.labelGridItem = {
    ...orderTotalDisplaySharedStyles.labelGridItem,
};
cartTotalDisplayStyles.valueGridItem = {
    ...orderTotalDisplaySharedStyles.valueGridItem,
};
cartTotalDisplayStyles.totalLabel = {
    ...orderTotalDisplaySharedStyles.totalLabel,
};
cartTotalDisplayStyles.totalValue = {
    ...orderTotalDisplaySharedStyles.totalValue,
};
cartTotalDisplayStyles.subtotalLabel = {
    ...orderTotalDisplaySharedStyles.label,
};
cartTotalDisplayStyles.subtotalValue = {
    ...orderTotalDisplaySharedStyles.value,
};
cartTotalDisplayStyles.promotionLabel = {
    ...orderTotalDisplaySharedStyles.label,
};
cartTotalDisplayStyles.promotionValue = {
    ...orderTotalDisplaySharedStyles.value,
};
cartTotalDisplayStyles.shippingAndHandlingLabel = {
    ...orderTotalDisplaySharedStyles.label,
};
cartTotalDisplayStyles.shippingAndHandlingValue = {
    ...orderTotalDisplaySharedStyles.value,
};
cartTotalDisplayStyles.taxLabel = {
    ...orderTotalDisplaySharedStyles.label,
};
cartTotalDisplayStyles.taxValue = {
    ...orderTotalDisplaySharedStyles.value,
};
cartTotalDisplayStyles.discountsLabel = {
    ...orderTotalDisplaySharedStyles.label,
};
cartTotalDisplayStyles.discountsValue = {
    ...orderTotalDisplaySharedStyles.value,
};
